<template>
    <a
        :href="link"
        class="z-report-block"
        :class="{ 'z-report-block--landscape-mode': landscapeMode }"
        target="_blank"
    >
        <div class="z-report-block__image" :style="`background-image: url(${image})`"></div>
        <div class="z-report-block__title">
            <span v-html="title"></span>
            <span class="z-report-block__wrapper">
                <span class="z-report-block__title-period" v-html="titlePeriod"></span>
                <tag rounded theme="gray-dark" size="l">PDF</tag>
            </span>
        </div>
    </a>
</template>

<script>

export default {
    name: 'z-card',
    props: {
        image: String,
        link: String,
        title: String,
        titlePeriod: String,
        landscapeMode: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="scss" src="./index.scss"></style>
